const orderProjectsByPathway = (projects, pathway) => {
  return pathway.projectsIds
    .map((projectId) => {
      return Object.values(projects).find((project) => project.id === projectId)
    })
    .filter((n) => Boolean(n))
}

const pathwayPath = (locale, slug) => `/${locale}/pathways/${slug}`

export { orderProjectsByPathway, pathwayPath }
